export const generateMenu = (preferences, servingSizes, residents, meals, mealOccurances) => {
  //   day: currentDay,
  //   mealType: meal.type || "unknown meal",
  //   mealId: mealId,
  //   mealName: meal.name,
  //   servings: servingSize,
  //   leftoverServings: servingSize - residents,
  //   calories: meal.calories,
  //   sodium: meal.sodium,
  //   carbs: meal.carbs
  const menu = [];
  //k - mealId, v - {k - servingSize, v - count}
  const totalDays = 28;
  let currentDay = 1;
  let prefIndex = 0;

  while (currentDay <= totalDays) {
    // Get current meal preference
    const mealId = preferences[prefIndex];
    const meal = meals.find(m => m.id === mealId);

    if (!meal || !meal.id) {
      prefIndex = (prefIndex + 1) % preferences.length;
      continue;
    }

    const servingSize = servingSizes[mealId] || 
      (Array.isArray(meal.servings) ? meal.servings[0] : meal.servings) || 
      4;
    
    if (!mealOccurances[mealId]) {
      mealOccurances[mealId] = {};
    }
    if (!mealOccurances[mealId][servingSize]) {
      mealOccurances[mealId][servingSize] = 0;
    }
    // Increment the count for this meal and serving size
    mealOccurances[mealId][servingSize]++;

    // Get serving size for this meal
    

    // Calculate how many full portions we can make from this serving size
    const portions = Math.floor(servingSize / residents);

    // Add entries for each portion of this meal
    for (let i = 0; i < portions && currentDay <= totalDays; i++) {
      menu.push({
        day: currentDay,
        mealType: meal.type || "unknown meal",
        mealId: mealId,
        mealName: meal.name,
        servings: servingSize,
        leftoverServings: servingSize - residents,
        calories: meal.calories,
        sodium: meal.sodium,
        carbs: meal.carbs,
        prepTime: meal.waitTime ? meal.prepTime + meal.waitTime : meal.prepTime,
      });
      currentDay++;
    }

    // Move to next meal preference
    prefIndex = (prefIndex + 1) % preferences.length;
  }

  return {menu, mealOccurances};
};